var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3117 15C17.9361 15 18.4327 14.6071 18.8787 14.0576C19.7916 12.9328 18.2928 12.034 17.7212 11.5938C17.14 11.1463 16.4912 10.8928 15.8333 10.8333M15 9.16667C16.1506 9.16667 17.0833 8.23392 17.0833 7.08333C17.0833 5.93274 16.1506 5 15 5",
    stroke: "#1C9BDB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.68797 15C2.06356 15 1.5669 14.6071 1.12096 14.0576C0.20808 12.9328 1.7069 12.034 2.27855 11.5938C2.85965 11.1463 3.50849 10.8928 4.16634 10.8333M4.58301 9.16667C3.43241 9.16667 2.49967 8.23392 2.49967 7.08333C2.49967 5.93274 3.43241 5 4.58301 5",
    stroke: "#1C9BDB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.73617 12.5926C5.8847 13.1191 3.65216 14.1942 5.01192 15.5395C5.67616 16.1966 6.41594 16.6666 7.34603 16.6666H12.6533C13.5834 16.6666 14.3232 16.1966 14.9874 15.5395C16.3472 14.1942 14.1147 13.1191 13.2632 12.5926C11.2664 11.358 8.73292 11.358 6.73617 12.5926Z",
    stroke: "#1C9BDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9163 6.25004C12.9163 7.86087 11.6105 9.16671 9.99967 9.16671C8.38884 9.16671 7.08301 7.86087 7.08301 6.25004C7.08301 4.63921 8.38884 3.33337 9.99967 3.33337C11.6105 3.33337 12.9163 4.63921 12.9163 6.25004Z",
    stroke: "#1C9BDB",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser22);
export default __webpack_public_path__ + "static/media/user22.356313237148c1e675d93707c8a65183.svg";
export { ForwardRef as ReactComponent };